import React, { useEffect, useState, createContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Request from "../Request/Request";
import axios from "../Request/axios";

const AppStorage = createContext();

const AppContext = ({ children }) => {
  const [userInfo, setUserInfo] = useState(() => JSON.parse(localStorage.getItem("userInfo")) || {});
  const [isLoading, setIsLoading] = useState(() => !!localStorage.getItem("p_u_t"));
  const [userAuthToken, setUserAuthToken] = useState("");
  const [zatcaEnvironmentVersion, setZatcaEnvironmentVersion] = useState(0);
  const [maintenanceModeActive, setMaintenanceModeActive] = useState(false);
  const [maintenanceChecked, setMaintenanceChecked] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    let userToken = localStorage.getItem("p_u_t");
    if (!!userToken) {
      axios.defaults.headers.common.Authorization = `Bearer ${userToken}`;
      setUserAuthToken(userToken);
    }
  }, []);

  useEffect(() => {
    if (userAuthToken !== "") {
      setIsLoading(true);
      Request.get("/getUserDetails")
        .then((result) => {
          setIsLoading(false);
          setUserInfo(result.data["user"]);
          localStorage.setItem("userInfo", JSON.stringify(result.data["user"]));
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response?.status === 503 && err.response?.data?.code === "MAINTENANCE_MODE") {
            return;
          }
          console.log("Error: ", err);
          if (err.response.status == 401) {
            toast.error("Unauthorized user.", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            });
            navigate("/");
          } else {
            toast.error("Something went wrong.", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            });
            navigate("/");
          }
          // take the user to login screen
        });
    } else {
      setUserInfo({});
      if (!localStorage.getItem("p_u_t")) {
        setIsLoading(false);
      }
    }
  }, [userAuthToken]);

  const checkMaintenanceMode = async () => {
    try {
      const response = await Request.get("/maintenance-mode/status");
      setMaintenanceModeActive(Boolean(response.data.enabled && !response.data.hasAccess));
    } catch (error) {
      console.log("Unable to check maintenance mode", error);
    } finally {
      setMaintenanceChecked(true);
    }
  };

  useEffect(() => {
    const handleMaintenance = () => {
      setMaintenanceModeActive(true);
      setMaintenanceChecked(true);
    };
    window.addEventListener("maintenance-mode", handleMaintenance);
    return () => {
      window.removeEventListener("maintenance-mode", handleMaintenance);
    };
  }, []);

  function setUserToken(token) {
    setUserAuthToken(token);
    localStorage.setItem("p_u_t", token);
  }
  function refreshZatcaEnvironmentData() {
    setZatcaEnvironmentVersion((version) => version + 1);
  }
  return (
    <AppStorage.Provider
      value={{
        userInfo,
        userAuthToken,
        setUserToken,
        isLoading,
        setIsLoading,
        zatcaEnvironmentVersion,
        refreshZatcaEnvironmentData,
        maintenanceModeActive,
        maintenanceChecked,
        checkMaintenanceMode,
      }}
    >
      {children}
    </AppStorage.Provider>
  );
};

export { AppStorage, AppContext };
